import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyCL6nfbIpuatte9k_lbA-42oaZ4e5FQzvA",
  authDomain: "learnify-446512.firebaseapp.com",
  projectId: "learnify-446512",
  storageBucket: "learnify-446512.firebasestorage.app",
  messagingSenderId: "586852639957",
  appId: "1:586852639957:web:cd8a70e931553efc93ae5c",
  measurementId: "G-3NC1TFLTVR",
};

const app = initializeApp(firebaseConfig);

// Lazily create the messaging instance. getMessaging() throws in environments
// without the required browser APIs (jsdom under tests, unsupported browsers),
// so it must never be called at module load — doing so previously crashed every
// test suite that imported a component depending on this module.
let messagingInstance;
function getMessagingInstance() {
  if (messagingInstance === undefined) {
    try {
      messagingInstance = getMessaging(app);
    } catch (error) {
      messagingInstance = null;
    }
  }
  return messagingInstance;
}

/**
 * Requests notification permission and returns the FCM token.
 * Returns null if messaging is unsupported, permission is denied, or token
 * generation fails.
 */
export async function getFCMToken() {
  try {
    const messaging = getMessagingInstance();
    if (!messaging) {
      return null;
    }
    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      console.warn("Notification permission not granted.");
      return null;
    }
    const token = await getToken(messaging, {
      vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
    });
    return token || null;
  } catch (error) {
    console.error("Error generating FCM token:", error);
    return null;
  }
}

export { app, getMessagingInstance };
